import React from 'react'
import './Mission.css'
import logo from './neurosferaLogo.png'
import shieldIcon from './icons/shield-fill.svg'
import gearIcon from './icons/gear-fill.svg'
import chartIcon from './icons/bar-chart-fill.svg'
import cpuIcon from './icons/cpu-fill.svg'
import puzzleIcon from './icons/puzzle-fill.svg'
import databaseIcon from './icons/database-fill.svg'

const missionNodes = [
  { className: 'mission__node mission__node_top', label: 'Автоматизация', icon: gearIcon },
  { className: 'mission__node mission__node_leftTop', label: 'Безопасность', icon: shieldIcon },
  { className: 'mission__node mission__node_rightTop', label: 'Бизнес', icon: chartIcon },
  { className: 'mission__node mission__node_leftBottom', label: 'Данные', icon: databaseIcon },
  { className: 'mission__node mission__node_bottom', label: 'Интеграции', icon: puzzleIcon },
  { className: 'mission__node mission__node_rightBottom', label: 'ИИ', icon: cpuIcon },
]

export default function Mission() {
  return (
    <section className="mission">
      <div className="mission__copy">
        <h2>Наша миссия</h2>
        <p>{'//'} <span>Создавать</span> инновационные программные <span>решения</span>, которые делают автоматизацию доступной, эффективной и безопасной для каждого.</p>
        <p>{'//'} <span>Наша цель</span> — не просто продавать софт, а <span>предлагать инструменты</span>, которые решают реальные проблемы, экономят время и открывают новые возможности в цифровом мире.</p>
      </div>

      <div className="mission__diagram" aria-label="Направления цифровой экосистемы Нейросферы">
        <svg className="mission__lines" viewBox="0 0 600 500" aria-hidden="true">
          <path d="M300 220 L300 82 M265 235 L145 145 M335 235 L455 145 M265 275 L145 365 M300 290 L300 430 M335 275 L455 365" />
        </svg>
        <div className="mission__core" aria-hidden="true">
          <img src={logo} alt="" />
        </div>
        {missionNodes.map((node) => (
          <div className={node.className} key={node.label}>
            <b><img src={node.icon} alt="" /></b>
            <span>{node.label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
